import ConfirmModal from "@/components/common/ConfirmModal";
import { asyncModal } from "@/components/ui/modal/utils";

export default function showConfirm(message, confirmBtnText, cancelBtnText) {
  return asyncModal({
    name: "app-confirm-modal",
    component: ConfirmModal,

    escapable: false,
    closeOnBackdrop: false,
    closable: false,

    props: {
      message,
      confirmBtnText,
      cancelBtnText
    }
  });
}
